<template>
        <div class="dashboard">
                <AdminHome v-if="user.role === 'admin'"></AdminHome>
                <CustomerHome v-else></CustomerHome>
        </div>
</template>

<script>
import { mapState } from 'vuex';
import AdminHome from './AdminHome';
import CustomerHome from './CustomerHome';

export default {
        components: {
                AdminHome,
                CustomerHome,
        },
        data() {
                return {};
        },
        computed: {
                ...mapState(['user']),
        },
};
</script>
